module.exports = __webpack_public_path__ + "img/menu2_mobile.723a67fd.png";